import { useEffect } from 'react';

import { getCurrentAccount } from 'api/generated/users/users';

import { getOktaUserId } from 'helpers/okta-session';

/**
 * Fires a lightweight GET for the current account (same intent as the legacy
 * `getCurrentUser()` call) to detect session expiry on specific screens.
 */
export const useSessionFreshnessPing = (): void => {
  useEffect(() => {
    const id = getOktaUserId();

    if (!id) return;

    void getCurrentAccount(id);
  }, []);
};
